import {
  getHttpBaseUrl,
  getServiceEnv,
  getWsUrl
} from "./serviceConfig"

const ws_url = getWsUrl()
const base_url = getHttpBaseUrl()

if (import.meta.env.DEV) {
  console.log("当前环境：开发环境", getServiceEnv())
  console.log("[HTTP]", base_url, "→ vite 代理本机后端（form-data 登录）")
  if (import.meta.env.VITE_WS_ENABLE === "true") {
    console.log("[WebSocket]", ws_url, import.meta.env.VITE_WS_LOCAL === "true" ? "← 本地 WS（内网 token）" : "← 优先云端 wss")
  } else {
    console.log("[WebSocket] 已关闭（VITE_WS_ENABLE=false）")
  }
}

export {
  base_url,
  ws_url
}
